export default __webpack_public_path__ + "static/media/ofs_800_smock.8fa3d86a.jpg";